import {Stack, Typography, useTheme} from '@mui/material';
import {StyledGrid} from 'presentation/components';
import {ControlledCheckbox} from 'presentation/components/ControlledCheckbox';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useFormContext} from 'react-hook-form';
import {RequestScheduleSchema} from '../RequestScheduleLayout/validation/schemas/RequestScheduleSchema';
import {StyledButton} from './styles';
import {RequestScheduleSelectPeriodProps} from './types';

const {weekDays, allDays} = translations['pt-br'].privateFlow.bookingFlow.requestSchedule;

export const RequestScheduleSelectPeriod = ({
	periodLabel,
	type,
	isLast,
	error,
}: RequestScheduleSelectPeriodProps) => {
	const {setValue, watch, setError} = useFormContext<RequestScheduleSchema>();
	const watchedData = watch();
	const {isMobile} = useMediaQueries();
	const {colors} = useTheme();

	const openList = watchedData[type]?.active;
	const listDays = watchedData[type]?.days;
	const allDaysActive = Object.values(listDays || {}).every(value => value);

	const handleSelectAll = (value: boolean) => {
		setValue(`${type}.days.monday`, value);
		setValue(`${type}.days.tuesday`, value);
		setValue(`${type}.days.wednesday`, value);
		setValue(`${type}.days.thursday`, value);
		setValue(`${type}.days.friday`, value);
		setValue(`${type}.days.saturday`, value);
		setValue(`${type}.days.sunday`, value);
	};

	const weekDaysConfig = [
		{
			key: 'monday',
			value: listDays?.monday,
			field: `${type}.days.monday`,
			label: weekDays.monday,
		},
		{
			key: 'tuesday',
			value: listDays?.tuesday,
			field: `${type}.days.tuesday`,
			label: weekDays.tuesday,
		},
		{
			key: 'wednesday',
			value: listDays?.wednesday,
			field: `${type}.days.wednesday`,
			label: weekDays.wednesday,
		},
		{
			key: 'thursday',
			value: listDays?.thursday,
			field: `${type}.days.thursday`,
			label: weekDays.thursday,
		},
		{
			key: 'friday',
			value: listDays?.friday,
			field: `${type}.days.friday`,
			label: weekDays.friday,
		},
		{
			key: 'saturday',
			value: listDays?.saturday,
			field: `${type}.days.saturday`,
			label: weekDays.saturday,
		},
		{
			key: 'sunday',
			value: listDays?.sunday,
			field: `${type}.days.sunday`,
			label: weekDays.sunday,
		},
	];

	return (
		<Stack
			gap={1}
			py={3}
			sx={{
				borderBottom: !isLast ? `0.5px solid ${colors.gray['40Percent']}` : 'none',
			}}>
			<Stack px={3}>
				<ControlledCheckbox
					checked={openList}
					handleCheck={(_, check) => {
						setValue(`${type}.active`, check);
						setError('availability', {message: ''});
						if (!check) {
							handleSelectAll(false);
						}
					}}
					label={periodLabel}
					fontWeight={600}
					customColor={colors.light.text.secondary}
					paddingLeft={'8px'}
				/>
			</Stack>
			{openList ? (
				<Stack gap={2}>
					<StyledGrid.Root>
						{weekDaysConfig.map(({value, field, key, label}) => (
							<StyledGrid.Item lg={1.7} md={1.7} sm={1.7} xs={1.7} key={key}>
								<StyledButton
									variant={value ? 'contained' : 'outlined'}
									onClick={() => {
										setError(`${type}`, {message: ''});
										setValue(`${field}` as keyof RequestScheduleSchema, !value);
									}}>
									{isMobile ? label.charAt(0) : label}
								</StyledButton>
							</StyledGrid.Item>
						))}
					</StyledGrid.Root>
					<StyledButton
						variant={allDaysActive ? 'contained' : 'outlined'}
						onClick={() => {
							setError(`${type}`, {message: ''});
							handleSelectAll(!allDaysActive);
						}}
						fullWidth>
						{allDays}
					</StyledButton>
					{error ? (
						<Stack>
							<Typography variant="caption" fontWeight={400} color={'error'}>
								{error}
							</Typography>
						</Stack>
					) : null}
				</Stack>
			) : null}
		</Stack>
	);
};
